import React, {forwardRef, useCallback, useImperativeHandle, useRef, useState} from "react";
import {FileUpload, FileUploadHandlerParam} from "primereact/fileupload";
import {easasAlert, easasErrorAlert} from "../../fragments/easas-global-fragment/EasasGlobalAlerts";
import {FilesApi} from "api/FilesApi";
import {ProgressBar} from "primereact/progressbar";

export type FileUploaderRef = {
    upload: () => void;
}

interface FileUploadParams {
    desc?: string;
    fileTags?: string[];
    isPublic?: boolean;
    onUploaded?: () => void;
    onErrored?: () => void;
}


export const FileUploader = forwardRef<FileUploaderRef, FileUploadParams>( (props, ref) => {
    const fileUpRef = useRef<FileUpload>(null);

    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    useImperativeHandle(ref, () => ({
        upload() {
            upload()
        }
    }));

    const upload = (desc?: string, tags?: string[]) => {
        fileUpRef.current!!.upload();
    }

    const onUploaded = () => {
        if(props.onUploaded) {
            props.onUploaded();
        }
    }

    const onErrored = () => {
        if(props.onErrored) {
            props.onErrored();
        }
    }

    const uploadHandler = (event: FileUploadHandlerParam) => {
        console.log("uploadHandler", event);
        if (event.files.length === 0) {
            easasErrorAlert("No files selected");
            return;
        }

        setIsUploading(true);

        const apiCall = props.isPublic ?
            () => FilesApi.uploadPublicFile(event.files[0], props.desc, props.fileTags, onProgress)
            : () => FilesApi.uploadFile(event.files[0], props.desc, props.fileTags, onProgress);

        apiCall().then((r) => {
            setIsUploading(false);

            if(!r.error) {
                easasAlert("File uploaded");
                onUploaded();
                fileUpRef.current!!.clear()
            } else {
                easasErrorAlert("Error uploading file");
                onErrored();
            }
        })
    }

    const onProgress = useCallback((event: number) => {
        setUploadProgress(event);
        console.log("onProgress", uploadProgress);
    }, []);


    return <>
        <FileUpload ref={fileUpRef} mode="basic" customUpload uploadHandler={uploadHandler} disabled={isUploading}/>

        {isUploading &&
            <div>
                Uploading...
                <ProgressBar value={uploadProgress}></ProgressBar>
            </div>
        }
    </>
});